import { defineMessages } from 'react-intl';

export default defineMessages({
    withdrawalDayMonth: {
        id: 'agent.directives.PaymentPlanChange.BankAccountInfo.Withdrawal Day of Month',
        defaultMessage: 'Withdrawal Day of Month',
    },
    financialInstitutionNumber: {
        id: 'agent.directives.PaymentPlanChange.BankAccountInfo.Financial Institution Number',
        defaultMessage: 'Financial Institution Number',
    },
    branchTransit: {
        id: 'agent.directives.PaymentPlanChange.BankAccountInfo.Branch Transit',
        defaultMessage: 'Branch Transit',
    },
    financialInstitutionName: {
        id: 'agent.directives.PaymentPlanChange.BankAccountInfo.Financial Institution Name',
        defaultMessage: 'Financial Institution Name',
    },
    bankAccountInformationTitle: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicyBilling.WMICBankAccountForm.WMICBankAccountForm.BankAccountInformationTitle',
        defaultMessage: 'Bank account information',
    },
    bankAccountInformationMessage: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicyBilling.WMICBankAccountForm.WMICBankAccountForm.BankAccountInformationMessage',
        defaultMessage: "Please review the member's banking information for accuracy prior to submitting.",
    },
    bankAccountNumber: {
        id: 'agent.directives.PaymentPlanChange.BankAccountInfo.Bank Account Number',
        defaultMessage: 'Bank Account Number',
    },
    bankAccountOwnerName: {
        id: 'agent.directives.PaymentPlanChange.BankAccountInfo.Bank Account Owner Name',
        defaultMessage: 'Bank Account Owner Name',
    },
    fiNameNotFoundFirstError: {
        id: 'agent.directives.PaymentPlanChange.Financial Institution Name not found first message',
        defaultMessage:
            'Financial Institution Name not found. Verify the Branch Transit and Financial Institution numbers and try again.',
    },
    fiNameNotFoundSecondError: {
        id: 'agent.directives.PaymentPlanChange.Financial Institution Name not found second message',
        defaultMessage:
            'Financial Institution Name not found. It may be invalid or unavailable at this time. Please select a different payment plan to proceed.',
    },
    reEnterBankAccountNumber: {
        id: 'wmic-pe-capability-policy-common-react.WMICPolicyWizard.pages.WMICPolicyBilling.WMICBankAccountForm.WMICBankAccountForm.Re-enter Bank Account Number',
        defaultMessage: 'Re-enter Bank Account Number',
    },
});
